import className from 'classnames/bind';
import { Heading, Container, FeaturedImage, Grid, ArrowRight } from '@/components';
import styles from './PostHero.module.scss';
import Link from 'next/link';
import { useFirstCategory } from '@/hooks/useFirstCategory';

let cx = className.bind(styles);

export function PostHero({ title, image, categories }) {
	const category = useFirstCategory(categories?.nodes);

	return (
		<section className={cx(['ns_post-hero', 'post-hero', 'bg-neutral-lightest'])}>
			<Container>
				<Grid colCount={12} alignItems="center" className={cx(['post-hero-grid'])}>
					<div className={cx('ns_blog-header-text-container', 'blog-header-text-container', !image && 'full')}>
						<div className={cx('post-breadcrumbs', 'is-style-heading-eyebrow')}>
							<Link href="/blog">Blog Home</Link>
							{category && (
								<>
									<span className={cx('category-arrow')}><ArrowRight /></span>
									<Link href={category.uri}>{category.name}</Link>
								</>
							)}
						</div>
						{title && <Heading className={cx('post-title', 'is-font-size-sm')}>{title}</Heading>}
					</div>
					{image && (
						<div className={cx('ns_featured-image-container', 'featured-image-container')}>
							<FeaturedImage image={image} className={cx('image')} priority={true} sizes='(max-width: 500px) 100vw, (max-width: 820px) 460px, (max-width: 1600px) 41vw, 580px' />
						</div>
					)}
				</Grid>
			</Container>
		</section>
	);
}
